import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14a7bdfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dw-sidebar-orders" }
const _hoisted_2 = { class: "dw-sidebar-orders__container" }
const _hoisted_3 = { class: "container__entities" }
const _hoisted_4 = {
  key: 0,
  class: "entities__state"
}
const _hoisted_5 = {
  key: 1,
  class: "entities__count"
}
const _hoisted_6 = {
  key: 2,
  class: "entities__action"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_button = _resolveComponent("dw-button")!
  const _component_dw_sidebar_entity = _resolveComponent("dw-sidebar-entity")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.computedOrders.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Список пуст"))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, " Количество: " + _toDisplayString(_ctx.computedOrders.length), 1)),
        (_ctx.selectedUnassignedTakes.length >= 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_dw_button, { onClick: _ctx.onMassAppointment }, {
                default: _withCtx(() => [
                  _createTextVNode("Массовое назначение")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedOrders, (entity) => {
          return (_openBlock(), _createBlock(_component_dw_sidebar_entity, {
            selectable: "",
            key: entity.type === 1 ? (entity as DispatcherWorkplaceTake).orderId : (entity as DispatcherWorkplaceDelivery).invoiceId,
            entity: entity,
            "selected-unassigned-takes": _ctx.selectedUnassignedTakes,
            "selected-feature-id": _ctx.selectedSidebarFeatureId,
            onClick: _ctx.onEntityClicked,
            onToggleUnassignedTake: _ctx.toggleUnassignedTake
          }, null, 8, ["entity", "selected-unassigned-takes", "selected-feature-id", "onClick", "onToggleUnassignedTake"]))
        }), 128))
      ])
    ])
  ]))
}